<template>
  <div>
    <swiper ref="category" :options="categorySwiperOption" class="categories">
      <swiper-slide v-for="category in categories" :key="category.categoryId">{{
        category.name
      }}</swiper-slide>
    </swiper>
    <swiper
      ref="menu"
      :options="menuSwiperOption"
      class="menus"
      @slideChange="menuChange"
      @resize="updateSwiper"
    >
      <swiper-slide v-for="menu in menuList" :key="menu.categoryId">
        <menu-list :items="menu.itemList" :column="menuDisplay" />
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import MenuList from '@/components/menuList/MenuList'

export default {
  components: {
    MenuList,
  },
  props: {
    activeCategoryIndex: {
      type: Number,
      required: true,
    },
  },
  data: (instance) => ({
    menuSwiperOption: {
      loop: true,
      spaceBetween: 10,
      preloadImages: false,
      loopedSlides: 2,
      initialSlide: instance.activeCategoryIndex,
    },
    categorySwiperOption: {
      loop: true,
      spaceBetween: 10,
      slidesPerView: 3.4,
      touchRatio: 0.4,
      slideToClickedSlide: true,
      centeredSlides: true,
      loopedSlides: 2,
      initialSlide: instance.activeCategoryIndex,
    },
  }),
  computed: {
    ...mapGetters({
      menuList: 'menu/getMenu',
      categories: 'menu/getCategories',
      activeCategoryId: 'menu/getActiveCategoryId',
      menuDisplay: 'menu/getMenuDisplay',
      getScrollPositionById: 'menu/getScrollPositionById',
    }),
    menuSwiper() {
      return this.$refs.menu.swiper
    },
    categorySwiper() {
      return this.$refs.category.swiper
    },
  },
  mounted() {
    // 2つのSwiperをお互いの制御下に設定
    this.menuSwiper.controller.control = this.categorySwiper
    this.categorySwiper.controller.control = this.menuSwiper

    // 描画完了後、前回閲覧時のスクロール位置を復元
    this.$nextTick(() => {
      this.categories.forEach((category) => {
        this.scrollMenu(category.categoryId)
      })
    })
  },
  methods: {
    ...mapActions({
      setActiveCategoryId: 'menu/setActiveCategoryId',
      setScrollPosition: 'menu/setScrollPosition',
    }),
    menuChange() {
      const nextActiveMenuIndex = this.menuSwiper.realIndex
      const nextActiveMenuId = this.menuList[nextActiveMenuIndex].categoryId
      if (this.activeCategoryId === nextActiveMenuId) return
      this.saveScrollPosition('previous')
      this.setActiveCategoryId(nextActiveMenuId)
    },
    saveScrollPosition(target) {
      const amount =
        target === 'current'
          ? this.menuSwiper.slides[this.menuSwiper.activeIndex].scrollTop
          : this.menuSwiper.slides[this.menuSwiper.previousIndex].scrollTop
      this.setScrollPosition({ id: this.activeCategoryId, amount })
    },
    scrollMenu(id) {
      const index = this.menuList.findIndex((category) => category.categoryId === id)
      const target = this.menuSwiper.slides[index + this.menuSwiperOption.loopedSlides]
      const position = this.getScrollPositionById(id)
      target.scrollTop = position
    },
    updateSwiper() {
      this.menuSwiper.update()
      this.categorySwiper.update()
    },
  },
}
</script>
<style lang="scss" scoped>
.categories {
  position: fixed;
  top: 55px;
  width: 100%;
  border-bottom: solid 2px #e5e4e2;
  background-color: #fff;
  z-index: 7;

  .swiper-slide {
    width: 100%;
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    font-weight: bold;
    color: #898989;

    // for iphone5/SE
    @media screen and (max-width: 375px) {
      font-size: 0.7rem;
    }
    &::after {
      position: absolute;
      content: '';
      display: block;
      width: 100%;
      height: 2px;
      background-color: transparent;
      bottom: 0;
      left: 0;
    }
  }

  .swiper-slide-active {
    position: relative;
    color: #d22523;

    &::after {
      background-color: #d22523;
    }
  }
}

.menus {
  height: calc(100vh - 103px);
  padding-top: 42px;

  .swiper-slide {
    background-color: #fff;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
